// QH Incentive - segment fill and guaranteed gradient dots
(function () {
  function formatMoneyWith(moneyFormat, value) {
    let amount = value / 100;
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(moneyFormat)) {
      amount = Math.round(amount);
      return moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amount.toLocaleString());
    }
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount.toFixed(2).toLocaleString());
  }

  function mount(el) {
    if (!el || el.dataset.qhMounted === "1") return;
    el.dataset.qhMounted = "1";

    let milestones = [];
    try { milestones = JSON.parse(el.dataset.milestones || "[]"); } catch (e) {}
    if (!milestones.length) return;

    let moneyFormat = '"₹{{amount}}"';
    try { moneyFormat = JSON.parse(el.dataset.moneyFormat || moneyFormat); } catch (e) {}

    const progressEl = el.querySelector(".qh-incentive__progress");
    const msgEl = el.querySelector(".qh-incentive__message");
    const top = milestones[milestones.length - 1]?.threshold || 1;

    function calcState(current) {
      let next = null;
      const achieved = [];
      for (const m of milestones) {
        if (current >= m.threshold) achieved.push(m);
        else if (!next) next = m;
      }
      return { achieved, next };
    }

    // Percent along bar within current segment prev -> next milestone
    function segmentPercent(current) {
      let prevTh = 0;
      let nextTh = milestones[0].threshold;
      for (let i = 0; i < milestones.length; i++) {
        const th = milestones[i].threshold;
        if (current >= th) {
          prevTh = th;
          if (i + 1 < milestones.length) {
            nextTh = milestones[i + 1].threshold;
          } else {
            nextTh = th;
          }
        } else {
          if (i === 0) nextTh = milestones[0].threshold;
          break;
        }
      }
      const span = Math.max(1, nextTh - prevTh);
      const frac = Math.max(0, Math.min(1, (current - prevTh) / span));
      const abs = prevTh + frac * (nextTh - prevTh);
      const pctAbs = (abs / top) * 100;
      return pctAbs;
    }

    function render(current) {
      const { next } = calcState(current);

      // Fill toward next milestone within current segment
      const pctAbs = segmentPercent(current);
      if (progressEl) progressEl.style.width = Math.max(0, Math.min(100, pctAbs)) + "%";

      // Message
      if (!msgEl) return;
      if (!next) {
        const last = milestones[milestones.length - 1];
        msgEl.innerHTML = `<strong>${last.label}</strong> unlocked!`;
        return;
      }
      const remaining = next.threshold - current;
      msgEl.innerHTML = `Add <strong>${formatMoneyWith(moneyFormat, remaining)}</strong> to unlock <strong>${next.label}</strong>!`;
    }

    // Initial render
    render(Number(el.dataset.total || 0));

    // Public refresh
    el.qhRefresh = function (newTotal) {
      render(Number(newTotal || 0));
    };
  }

  function initAll(root) {
    (root || document).querySelectorAll(".qh-incentive__box").forEach(mount);
  }

  // Public API
  window.QHIncentive = {
    initAll,
    refreshAll(newTotal) {
      document.querySelectorAll(".qh-incentive__box").forEach(el => el.qhRefresh && el.qhRefresh(newTotal));
    }
  };

  // Boot
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  // Section lifecycle
  document.addEventListener("shopify:section:load", e => initAll(e.target));
  document.addEventListener("shopify:section:select", e => initAll(e.target));

  // Cart updates hook
  document.addEventListener("cart:updated", e => {
    const newTotal = e && e.detail && e.detail.cart && e.detail.cart.total_price;
    if (typeof newTotal === "number") window.QHIncentive.refreshAll(newTotal);
  });

  // Drawer DOM changes fallback
  const observer = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches(".qh-incentive__box")) mount(node);
        if (node.querySelectorAll) initAll(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
